import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Star } from 'lucide-react';
import Button from './ui/Button';

const PublicNavbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="bg-white/80 backdrop-blur-sm border-b border-purple-100 w-full z-50 sticky top-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center gap-2 text-xl font-bold">
            <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-pink-500 to-purple-600 flex items-center justify-center">
              <Star className="w-3.5 h-3.5 text-white" fill="white" />
            </div>
            <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
              MapaAstral<span className="text-pink-500">.ai</span>
            </span>
          </Link>

          {/* Desktop menu */}
          <div className="hidden md:flex items-center gap-4">
            <Link to="/faq" className="px-4 py-2 text-gray-600 hover:text-purple-600 transition-colors">
              FAQ
            </Link>
            <Link to="/login" className="px-4 py-2 text-gray-600 hover:text-purple-600 transition-colors">
              Login
            </Link>
            <Button to="/signup" size="sm">
              Criar Conta
            </Button>
          </div>

          {/* Mobile hamburger */}
          <button
            className="md:hidden p-2 text-gray-600 hover:text-purple-600"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label={mobileMenuOpen ? 'Fechar menu' : 'Abrir menu'}
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile menu dropdown */}
        {mobileMenuOpen && (
          <div className="md:hidden pb-4 border-t border-purple-50">
            <div className="flex flex-col gap-1 pt-2">
              <Link
                to="/faq"
                onClick={() => setMobileMenuOpen(false)}
                className="px-3 py-2.5 rounded-lg text-gray-600 hover:text-purple-600 hover:bg-purple-50 transition-colors"
              >
                FAQ
              </Link>
              <Link
                to="/login"
                onClick={() => setMobileMenuOpen(false)}
                className="px-3 py-2.5 rounded-lg text-gray-600 hover:text-purple-600 hover:bg-purple-50 transition-colors"
              >
                Login
              </Link>
              <Button
                to="/signup"
                onClick={() => setMobileMenuOpen(false)}
                size="sm"
                className="mx-3 mt-2"
              >
                Criar Conta
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default PublicNavbar;
